import $ from "jquery";
import GLightbox from 'glightbox';
$(document).ready(function () {
    if ($(".woocommerce-page.single-product").length) {
        var lightbox_1 = GLightbox({
            selector: ".woocommerce-product-gallery__wrapper a"
        });
        setInterval(function () {
            lightbox_1.reload();
        }, 1000);
    }
});
